import { cn } from "@repo/design-system/utils/cn";
import type { ElementType, HTMLAttributes } from "react";

function Skeleton({
  className,
  as,
  ...props
}: HTMLAttributes<HTMLDivElement> & { as?: ElementType }) {
  if (as) {
    const Comp = as;
    return (
      <Comp
        className={cn("animate-pulse rounded-md bg-muted", className)}
        {...props}
      />
    );
  }

  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
